export const Constants = {
  login: "Login",
  LoginAccount: "Login to your Account ",
  userName: "User Name",
  password: "Password",
  rememberMe: "Remember Me",
  forgotPassword: "Forgot Password ?",
  orText: "OR",
  poweredBy: "Powered by Nural",
  nuralService: "Nural Service",
  userNameValidation: "User Name is Required",
  IncorrectErrorMessage: "Incorrect username or password. Please try again.",
  errorOccured: "An error occurred. Please try again.",
  emailIdValidation: "Email Id is required",
  passwordValidation: "Password is Required",
  getYourPassword: "Get your Password",
  enterUserName: "Enter User Name",
  enterEmail: "Enter Email ID",
  backBtn: "Back",
  welcomeText: " Welcome !",
  dashboard: "Dashboard",
  grn: "GRN",
  serviceCenter: "Service Center",
  inventory: "Inventory",
  escalation: "Escalation",
  trc: "TRC",
  reports: "Reports",
  partIssue: "Part Issue",
  lastLogin: "Last Login",
  dashboardMtd: "Service Center Dashboard",
  jobsheetNo: "Jobsheet No",
  ticketNo: "Ticket No",
  docketNo: "Docket No",
  trayNo: "Tray No",
  bin: "Bin",
  select: "Select",
  search: "Search",
  assignToEngineer: "Assign to Engineer",
  assignBtn: "Assign",
  ticketAcknowledge: "Ticket Acknowledge",
  type: "Type",
  fromDate: "From Date",
  toDate: "To Date",
  acknowledgeBtn: "Acknowledge",
  engineer: "Engineer",
  issueBtn: "Issue",
  customerName: "Customer Name",
  product: "Product",
  model: "Model",
  defect: "Defect",
  generateJobsheetNo: "Generate Jobsheet No",
  printLabel: "Print Label",
  printTraylabel: "Print Tray Label",
  reject: "Reject",
  onHold: "On Hold",
  forceCloseTray: "Force Close Tray",
  reasonForRejection: "Reason For Rejection",
  reasonForOnHold: "Reason For On Hold",
  rejectionReason: "Rejection Reason",
  onHoldReason: "On Hold Reason",
  submitBtn: "Submit",
  enterRemarks: "Enter Remarks",
  sparePartCreation: "Spare Part Creation",
  sparePartMapping: "Spare Part Mapping",
  resionMaster: "Reason Master",
  warranty: "Warranty",
  manageservicecharge: "Manage Service Charge",
  Manageconfigurationmaster: "Manage Configuration Master",
  Repairdashboard: "Repair Dashboard",
  Servicetatdashboard: "Service Tat Dashboard",
  Model: "Model",
  Bulkticketupload: "Bulk Ticket Upload",
  Upload: "Upload Stock",
  Productsku: "Product SKU",
  callCenter: "Call Center",
  partReturn: "Part Return",
  receivedProduct: "Received Product",
  oem: "OEM",
  condition: "Condition",
  AssigntoSC: "Assign to SC",
  cannibilization: "Cannibilizition",
  trayPrint: "Tray Print",
  jobsupload: "Upload Jobs",
  reset: "Reset",
  superAdmin : "Super Admin",
  customer: 'Customer',
  callDashboard: 'Call Dashboard',
  help: 'Help',
  jobsheetSearch: 'Jobsheet Search',
  create: "Create",
  update : "Update",
  save: "Save",
  cancel: "Cancel",
  package: "Package",
  createPackage: "Create Package",
  exportToExcel: "Export To Excel",
  };
